<nav class="breadcrumb-holder" aria-label="breadcrumb">
  <ol class="breadcrumb d-inline ps-0">
    <li *ngIf="showPreviousPage" class="breadcrumb-item d-inline">
      <a class="h1" [routerLink]="link" [attr.data-test-id]="dataTestId">
        {{ pageToNavigateTitle | translate }}
      </a>
    </li>
    <li class="breadcrumb-item h1 d-inline" aria-current="page" [attr.data-test-id]="titleDataTestId">
      <span>{{ pageTitle | translate }}</span>
      <span [attr.data-test-id]="getBadgeStyle()" [ngClass]="getBadgeStyle()">{{ status | translate }}</span>
    </li>
  </ol>
</nav>
